import {useMutation} from '@tanstack/react-query';

import api from 'services/api';

const useDownloadResultTreatments = () => {
    const downloadResults = async (trialId) => {
        try {
            const result = await api.get(`api/v1/trials/${trialId}/results/download/treatments`);
            let filename = ''
            const header = result.headers.get('Content-Disposition');
            if(header) {
                const parts = header.split(';');
                filename = parts[1].split('=')[1];
            }
            const data = await result.blob();
            return {data, filename};
        } catch (e) {
            return Promise.reject(e);
        }
    };

    return useMutation(({trialId}) => downloadResults(trialId));
};

export default useDownloadResultTreatments;